import React from 'react';
import {useSelector} from 'react-redux';

import {selectIsAnyConsumerProducts} from '@/state/selectors/consumer';
import {selectAvailableJourneys, selectInProgressJourneys} from '@/state/selectors/consumerLoyalty';

import EarnBadges from './EarnBadges/EarnBadges';
import FinishWhatYouStarted from './FinishWhatYouStarted/FinishWhatYouStarted';

const LoyaltySection = () => {
    const startedJourneys = useSelector(selectInProgressJourneys);
    const isAnyConsumerProducts = useSelector(selectIsAnyConsumerProducts);
    const availableJourneys = useSelector(selectAvailableJourneys);

    const hasStartedJourneys = startedJourneys?.length > 0;
    const hasAvailableJourneys = availableJourneys?.length > 0;

    if ((!hasStartedJourneys && !hasAvailableJourneys) || !isAnyConsumerProducts) return;

    return (
        <section className='my-2 flex max-w-2xl flex-col gap-4 bg-romance p-4 md:bg-transparent md:px-8 lg:px-16 xl:mx-auto xl:box-content'>
            {hasStartedJourneys && <FinishWhatYouStarted journeys={startedJourneys} />}
            {!hasStartedJourneys && hasAvailableJourneys && <EarnBadges availableJourneys={availableJourneys} />}
        </section>
    );
};

export default LoyaltySection;
